module.exports = __webpack_public_path__ + "static/logo-500x500-4380b7972fc477aa435a166007475360.svg";